var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TodoPlugin',{attrs:{"farm-id":"all","farm-only":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }